import React, { useState, useEffect, Fragment } from "react"
import moment from "moment"
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  InputAdornment,
  RadioGroup,
  FormControl,
  Radio,
  FormControlLabel,
  CircularProgress
} from "@material-ui/core"
import { useSelector, useDispatch } from "react-redux"
import useStyles from "./styles"
import { toggleBillingAdjustmentDialog } from "../../../../actions/billingDialogs"
import { adjustClientPayment } from "../../../../actions/billing"
import LoadingButton from "../../../LoadingButton/index"
import GreenButton from "../../Common/GreenButton/index"
import formatNumberWithCommas from "../../../../utils/formatNumberWithCommas"
import { openSnackBar } from "../../../../actions/snack-bar"

const BillingAdjustmentDialog = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const [adjustmentAmount, setAdjustmentAmount] = useState()
  const [descriptionText, setDescriptionText] = useState("")
  const [allowedMax, setAllowdMax] = useState(0)
  // const [allowedMin, setAllowedMin] = useState(0)
  const [adjustmentType, setAdjustmentType] = useState(null)
  const [hasError, setHasError] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [isLoading, setIsLoading] = useState(false);


  const open = useSelector(
    state => state.billingDialogs.billingAdjustmentDialogOpen
  )
  const data = useSelector(state => state.billingDialogs.data)
  const generalData = useSelector(state => state.billing.generalData)

  const payeeName = (data && data.payeeName) || ""
  const payeeId = (data && data.payeeId) || null
  const outstandingBalance = (data && data.outstandingBalance) || 0
  const adjustmentFunc = (data && data.adjustmentFunc) || null
  const adjustmentFuncArgs = (data && data.adjustmentFuncArgs) || []

  let remaining = data && data.billingData && data.billingData.remaining >= 0 ? data.billingData.remaining : 0;

  if (data && data.billingData && data.billingData.remaining >= 0 && adjustmentAmount > 0) {
    remaining = adjustmentType === "add" ? (data.billingData.remaining - parseFloat(adjustmentAmount)) : (data.billingData.remaining + parseFloat(adjustmentAmount));
  }
  let deposit = data && data.billingData && data.billingData.paid ? data.billingData.paid : 0;


  if (data && data.billingData && data.billingData.paid >= 0 && adjustmentAmount > 0) {
    deposit = adjustmentType === "add" ? (data.billingData.paid + parseFloat(adjustmentAmount)) : (data.billingData.paid - parseFloat(adjustmentAmount));
  }

  const handleClose = () => {
    dispatch(toggleBillingAdjustmentDialog(false))
    setTimeout(() => {
      setAdjustmentAmount()
      setDescriptionText("")
      setHasError(false)
      setIsLoading(false)
      setErrorMessage("")
    }, 200)
  }


  const handleAdjustmentTypeChange = (type) => {
    setAdjustmentType(type.target.value)
  }

  const executeAdjustmentFunc = () => {
    const invoiceId = generalData.client_invoice_id
    const depositRequired = generalData.deposit_required
    const invoice_id = generalData.client_invoice_id
    const shoot_id = generalData.id
    const creator_id = generalData.creator_id
    const description = descriptionText
    const type = adjustmentType
    const updated_at = moment().format()
    const payment_amount = adjustmentAmount
    const previous_remaining = data.billingData.remaining
    const previous_deposit = generalData.full_amount
    const created_at = generalData.full_paid_date

    setIsLoading("generalData", generalData)

    let callData = {
      amountColumn: "full_amount",
      amount: deposit,
      logsData: {
        invoice_id,
        shoot_id,
        creator_id,
        description,
        type,
        updated_at,
        payment_amount,
        previous_deposit,
        previous_remaining,
        created_at
      }
    }

    let updateData
    generalData.payment_logs.push(callData.logsData)

    updateData = {
      payment_logs: generalData.payment_logs,
      full_amount: deposit
    }


    dispatch(adjustClientPayment(callData, invoiceId, updateData))
      .then(() => {

        dispatch(
          openSnackBar({
            message: "Adjusted Client Payment.",
          })
        )
        handleClose()
      })
      .catch(err => {
        console.log(err)
        // toggleCheckboxLoading(false)
        dispatch(
          openSnackBar({
            message: "Error Adjusting the Client Payment.",
          })
        )
      })


  }


  const handleAdjustmentAmount = (amount) => {

    let errorState = false;
    let errorMessageState = "";
    if (amount == 0 || amount < 0) {
      errorState = true
      errorMessageState = "Adjustment amount should be greater then 0"
      setHasError(errorState)
      setErrorMessage(errorMessageState)
      return;
    }


    if (adjustmentType === "add") {

      // amount should be less then or equal to remaining

      if (amount > data.billingData.remaining) {

        errorState = true
        errorMessageState = "Adjustment amount should be less then or equal to remaining amount"
      } else {
        errorState = false
        errorMessageState = ""
        setAdjustmentAmount(amount)
      }
    } else {

      // amount should be less then or equal to deposit
      if (amount > data.billingData.paid) {
        errorState = true
        errorMessageState = "Adjustment amount should be less then or equal to deposit amount"
      } else {
        errorState = false
        errorMessageState = ""
        setAdjustmentAmount(amount)
      }

    }


    setHasError(errorState)
    setErrorMessage(errorMessageState)
  }

  return (
    <Dialog
      open={open}
      maxWidth="xs"
      PaperProps={{
        classes: {
          root: classes.paper,
        },
      }}
    >

      <DialogTitle disableTypography className={classes.title}>
        <Typography variant="h2" align="left">
          Payment Adjustment Dialog
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box mb={1} mt={1}>
          <Typography>{payeeName}</Typography><s></s>
          <Typography>{payeeId}</Typography>
          {/* this is the new feature */}

          <Box className={classes.rowWrapper}>
            <Typography
              style={{ fontSize: "16px", fontWeight: 600, textAlign: "left" }}
            >
              Current Payment Stats
            </Typography>

          </Box>
          {data && data.billingData && data.billingData.original && data.billingData.additional >= 0 &&
            <Box mt={1} className={classes.rowWrapper}>
              <Typography className={classes.blueFont}>Balance Due:</Typography>
              <Typography className={classes.blueFont}>
                $ {formatNumberWithCommas(data.billingData.original + data.billingData.additional)}
              </Typography>
            </Box>
          }

          {data && data.billingData && data.billingData.original && data.billingData.payAble &&
            <Box mt={1} className={classes.rowWrapper}>
              <Typography className={classes.redFont}>Non Billable:</Typography>
              <Typography className={classes.redFont}>
                - $ {formatNumberWithCommas(data.billingData.original - data.billingData.payAble)}

              </Typography>
            </Box>

          }
          {deposit >= 0 &&
            <Box mt={1} className={classes.rowWrapper}>
              <Typography className={classes.redFont}>Deposit:</Typography>
              <Typography className={classes.redFont}>
                - $ {formatNumberWithCommas(deposit)}
              </Typography>
            </Box>
          }
          {remaining >= 0 &&
            <Box mt={1} className={classes.rowWrapper}>
              <Typography className={classes.greenFont}>Remaining:</Typography>
              <Typography className={classes.greenFont}>
                $ {formatNumberWithCommas(remaining)}
              </Typography>
            </Box>
          }

          <Typography variant="subtitle2" style={{ fontSize: "14px" }}>
            Adjustment Type:
          </Typography>
          <FormControl>
            <RadioGroup
              aria-label="select-payment-method"
              name="payment-method"
              value={adjustmentType}
              onChange={handleAdjustmentTypeChange}
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              mt={2}
              mb={2}
              className={classes.radioGroup}
            >
              <FormControlLabel
                className={classes.radio}
                value="add"
                control={<Radio />}
                label="Add Payment"
              />
              <FormControlLabel
                className={classes.radio}
                value="subtract"
                control={<Radio />}
                label="Subtract Payment"
              />
            </RadioGroup>
          </FormControl>

          {/* ends here */}
          {data && data.billingData && data.billingData.remaining >= 0 && data.billingData.paid && adjustmentType &&

            <Fragment>
              <Typography variant="subtitle2" style={{ fontSize: "14px" }}>
                Adjustment Amount:
              </Typography>
              <TextField
                fullWidth
                type="number"
                variant="outlined"
                // min="0"
                // max={adjustmentType === "add" ? parseInt(data.billingData.remaining) : parseInt(data.billingData.paid)}
                value={adjustmentAmount}
                disabled={!adjustmentType}
                error={hasError}
                helperText={errorMessage}
                onChange={e => handleAdjustmentAmount(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
                style={{ marginBottom: "10px" }}
              />
              <Typography variant="subtitle2" style={{ fontSize: "14px" }}>
                Description:
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={3}
                variant="outlined"
                placeholder="Type Description Here"
                disabled={!adjustmentType}
                value={descriptionText}
                onChange={e => setDescriptionText(e.target.value)}
                style={{ marginBottom: "10px" }}
              />
            </Fragment>}
        </Box>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant="text"
          onClick={handleClose}
          className={classes.cancelButton}
        >
          Cancel
        </LoadingButton>
        <GreenButton variant="contained"
          color={"green"}
          disabled={hasError}
          onClick={executeAdjustmentFunc}
        >
          {isLoading ? (
            <CircularProgress size={22} style={{ color: "#fff" }} />
          ) : (
            "Submit"
          )}
        </GreenButton>
      </DialogActions>
    </Dialog>
  )
}

export default BillingAdjustmentDialog
